<template>
    <nav aria-label="Breadcrumb">
        <ol class="breadcrumb">
            <li v-for="(item, index) in items"
                :key="index"
                class="breadcrumb-item">
                <Link v-if="item.url"
                      :href="item.url">
                {{ item.title }}
                </Link>
                <span :class="items.length == 1 ? 'fw-bold' : 'fw-normal'"
                      v-else>{{ item.title }}</span>
                <span v-if="index < items.length - 1"
                      class="px-1">|</span>
            </li>
        </ol>
    </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Link } from '@inertiajs/vue3'
import { BreadcrumbResource } from "~types/concierge";


export default defineComponent({
    name: 'Breadcrumb',
    components: { Link },
    props: {
        items: {
            type: Array as () => BreadcrumbResource[],
            required: true
        }
    }
});
</script>

<style scoped lang="scss">
.breadcrumb {
    padding: 0;
    margin: 0;
    list-style: none;
}

.breadcrumb-item {
    font-size: var(--font-size-smaller);
    display: inline-block;
}

a.breadcrumb-item {
    &:hover {
        text-decoration: underline;
    }
}
</style>
